export const GET_SERVICE_ACCOUNTS_REQUEST = 'GET_SERVICE_ACCOUNTS_REQUEST';
export const CREATE_SERVICE_ACCOUNT_REQUEST = 'CREATE_SERVICE_ACCOUNT_REQUEST';
export const ROTATE_SERVICE_ACCOUNT_REQUEST = 'ROTATE_SERVICE_ACCOUNT_REQUEST';
export const ACTIVATE_SERVICE_ACCOUNT_REQUEST = 'ACTIVATE_SERVICE_ACCOUNT_REQUEST';
export const DEACTIVATE_SERVICE_ACCOUNT_REQUEST = 'DEACTIVATE_SERVICE_ACCOUNT_REQUEST';
export const DELETE_SERVICE_ACCOUNT_REQUEST = 'DELETE_SERVICE_ACCOUNT_REQUEST';

export const getServiceAccounts = (callback) => ({
    type: GET_SERVICE_ACCOUNTS_REQUEST,
    payload: { callback },
});

export const createServiceAccount = (data, callback) => ({
    type: CREATE_SERVICE_ACCOUNT_REQUEST,
    payload: { data, callback },
});

export const rotateServiceAccount = (id, callback) => ({
    type: ROTATE_SERVICE_ACCOUNT_REQUEST,
    payload: { id, callback },
});

export const activateServiceAccount = (id, callback) => ({
    type: ACTIVATE_SERVICE_ACCOUNT_REQUEST,
    payload: { id, callback },
});

export const deactivateServiceAccount = (id, callback) => ({
    type: DEACTIVATE_SERVICE_ACCOUNT_REQUEST,
    payload: { id, callback },
});

export const deleteServiceAccount = (id, callback) => ({
    type: DELETE_SERVICE_ACCOUNT_REQUEST,
    payload: { id, callback },
});
